import { useDealContext } from "src/dm/components/DealLayout/DealLayout";
import DealNotes from "src/dm/components/DealNotes/DealNotes";

const DealNotesPage = () => {
  const deal = useDealContext();
  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Notes</h2>
      <DealNotes dealId={deal.dealId} />
    </div>
  );
};

export default DealNotesPage;
